export class FinancialStatement {
  code: string | undefined;
  currentAssets: number | undefined;
  fixedAssets: number | undefined;
  shortTermLiabilities: number | undefined;
  longTermLiabilities: number | undefined;
  equities: number | undefined;
  netProfitLoss: number | undefined;
  paidInCapital: number | undefined;
  commercialDebts: number | undefined;
  stocks: number | undefined;
  cash: number | undefined;
  date: Date | undefined;
  lang: string;
  country: string;
  createDate: Date | undefined;

  cashRatio: number | undefined;
  acidTestRatio: number | undefined;
  currentRatio: number | undefined;
}
